import React from 'react';
import { Grid, Chip, Box, Button } from '@material-ui/core';
import useStyles from './Styles';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import CustomizedSelect from '../common/CustomizedSelect';


const FilterTogglebar = () => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const options = [
        { label: 'Subject', value: 0 },
        { label: 'Subject', value: 1 },
        { label: 'Subject', value: 2 },
        { label: 'Subject', value: 3 }
    ];

    return (
        <Grid container classes={{ root: classes.filterContainer }} >
            {
                !open ? (
                    <>
                        <Button variant="outlined" startIcon={<ExpandMore />} className={classes.expandBtn} onClick={ () => setOpen(true) }>
                            Show
                        </Button>
                        <Box className={ classes.chips }>
                            <Chip label="Scenarios: Colorado River is Replaced with Bees" variant='outlined' className={ classes.chip }/>
                            <Chip label="Big River Policy: Lorem ipsum dolor sit amet" variant='outlined' className={ classes.chip }/>
                        </Box>
                    </>
                ) : (
                    <>
                        <Button variant="outlined" startIcon={<ExpandLess />} className={classes.expandBtn} onClick={ () => setOpen(false) }>
                            Hide
                        </Button>
                        <Grid container className={ classes.chips }>
                            <CustomizedSelect background={"#FFFFFF"} label="Scenario" options={options} />
                            {/* <Grid item style={{ flexGrow: 1 }}><CustomizedSelect background={"#FFFFFF"} label="Big River Policy" options={options} /></Grid> */}
                            <Button variant='contained' color='primary' className={classes.applyBtn}>Apply</Button>
                        </Grid>
                    </>       
                )
            }
        </Grid>
    );
};

export default FilterTogglebar;